import { FC } from "react";
import { TradingPair } from "shared/model";
import { formatPayoutPercent } from "shared/utils";
import { PUBLIC_BASE_URL } from "config";

import styles from "./PairList.module.css";

type Props = {
  pairs: TradingPair[];
  activeIndex: number;
  onSelect: (symbol: string) => void;
  onHover: (index: number) => void;
  itemRefs: React.MutableRefObject<(HTMLDivElement | null)[]>;
};

export const PairList: FC<Props> = ({
  pairs,
  activeIndex,
  onSelect,
  onHover,
  itemRefs,
}) => {
  return (
    <div className={styles.list}>
      <div className={styles.listTitle}>
        <div className={styles.assetTitle}>Asset</div>
        <div className={styles.payoutTitle}>Payout</div>
      </div>
      <div className={styles.assetList}>
        {pairs.map((pair, index) => (
          <div
            key={pair.symbol}
            ref={(el) => (itemRefs.current[index] = el)}
            onClick={() => onSelect(pair.symbol)}
            onMouseEnter={() => onHover(index)}
            className={`${styles.item} ${
              index === activeIndex ? styles.activeItem : ""
            } ${pair.isMarketOpen ? "" : styles.marketClosed}`}
          >
            <div className={styles.simbol}>
              <img
                src={`${PUBLIC_BASE_URL}/assets/symbols/${pair.icon}`}
                alt={pair.symbol}
                className={styles.icon}
              />
              <span>{pair.symbol}</span>
            </div>
            <div className={styles.payout}>
              {" "}
              +{formatPayoutPercent(pair.winPayoutPercent)}%
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
